import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csifelse(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
  
      <Helmet>
 
 <title>Learn Free JavaScript If Else If Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript if else tutorial for beginners.if else in Javascript is used for making a decision.If and else can be a block statement, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript if else,Javascript if else for,javascript if else,javascript if else statement,javascript if else shorthand,javascript if else one line,javascript if else function,javascript if else condition,if else foreach Javascript,Javascript foreach if else" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-if-else" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">If else statement in Javascript
</h1>
<div className="first">
        <a href="/javascript-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<h2 className="mt-4 mh2">If-Else Javascript Syntax :</h2>




    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        

  {"\n"}
  <span className="qwerty-10">if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;Statement;</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  

  {"\n"}
  <span className="qwerty-10">else </span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;Statement;</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  {"\n"}  {"\n"}
 </code>
      </pre>        
    </div>



<h2 className="headings">Q-Write a program to input a number and check this value is greater than 1000 or not in the Javascript tutorial?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">450; </span>
          {"\n"}

    <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#62;</span> 
        <span className="qwerty-1">1000</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"This "</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">+</span>
        <span className="qwerty-10">" no is Greater than 1000"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      <span className="qwerty-5">&nbsp;&nbsp;else</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"This "</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">+</span>
        <span className="qwerty-10">" no is Smaller than 1000"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}




<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
      
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;This </span>             
          <span className="qwerty-10">450 </span>  
          <span className="qwerty-3">no is Smaller than </span>   
          <span className="qwerty-5">1000 </span>         
          {"\n"}
          
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Write a program to check a no is even or odd in a Javascript tutorial?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">160208; </span>
          {"\n"}

    <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">%</span> 
        <span className="qwerty-1">2</span>
        <span className="qwerty-8">==</span> 
        <span className="qwerty-1">0</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"This "</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">+</span>
        <span className="qwerty-10">" no is Even no"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      <span className="qwerty-5">&nbsp;&nbsp;else</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"This "</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">+</span>
        <span className="qwerty-10">" no is Odd no"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}




<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
      
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;This </span>             
          <span className="qwerty-10">160208 </span>  
          <span className="qwerty-3"> no is Even no </span> 
          {"\n"}
          
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">
        Q-Write a program to input a number and check this value is greater than
        1000 or not in the Javascript tutorial?
      </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">40; </span>
            {"\n"}
            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">b</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">50; </span>
            {"\n"}

            <span className="qwerty-5">&nbsp;&nbsp;if</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-8">&#62;</span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-1">)</span>
            {"\n"}

            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-2">write</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-1">"This "</span>
            <span className="qwerty-8">+</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-8">+</span>
            <span className="qwerty-1">" no is Greater no"</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
            <span className="qwerty-5">&nbsp;&nbsp;else</span>
            {"\n"}

            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-2">write</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-1">"This "</span>
            <span className="qwerty-8">+</span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-8">+</span>
            <span className="qwerty-1">" no is Greater no"</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}

            <span className="qwerty-3">&#60;/</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            {"\n"}
          </code>
        </pre>   
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-3">&nbsp;This </span>
              <span className="qwerty-5">50</span>
              <span className="qwerty-3"> no is Greater no </span>
              {"\n"}
            </code>
            {"   "}
          </pre>
        </div>
      </div>

<h2 className="mt-4 mh2">Nested if list in Javascript tutorial:</h2>





<h2 className="headings">
      Q-Write a program to input a no and after Check no is Greater, Less or Between in Javascript Example?
      </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">840; </span>
            {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span> 
        <span className="qwerty-8">&#60;</span> 
        <span className="qwerty-1">100</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"i is Less than = "</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;else </span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}


  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span> 
        <span className="qwerty-8">&#62;=</span> 
        <span className="qwerty-1">1000</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"greater than 1000"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}

  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;else </span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"between 100 and 1000"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  




  {"\n"}




            <span className="qwerty-3">&#60;/</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-3">&nbsp;between 100 and 1000 </span>
              {"\n"}
            </code>
            {"   "}
          </pre>
        </div>
      </div>




<h2 className="headings">
      Q-Write a Gender Male, Female or Another Gender Nested List Program in Javascript?
      </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">sex</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">'m'; </span>
            {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">sex</span> 
        <span className="qwerty-8">==</span> 
        <span className="qwerty-1">'m'</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"This is male</span>
    
          <span className="qwerty-1">"</span>

      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;else </span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}


  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">sex</span> 
        <span className="qwerty-8">==</span> 
        <span className="qwerty-1">'f'</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"This is female"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}

  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;else </span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"not male and not female"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
{"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"I have checked gender"</span>
      <span className="qwerty-1">);</span>




  {"\n"}




            <span className="qwerty-3">&#60;/</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-3">&nbsp;this is male </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;I have checked gender  </span>
              {"\n"}
            </code>
            {"   "}
          </pre>
        </div>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/javascript-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>

    </div>
)

}
export default Csifelse;